function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M58 30H90V94H58M50 14V6H18V14H10V94H58V14H50Z",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44 20H48V24H44V20ZM36 20H40V24H36V20ZM28 20H32V24H28V20ZM20 20H24V24H20V20ZM44 30H48V38H44V30ZM36 30H40V38H36V30ZM28 30H32V38H28V30ZM20 30H24V38H20V30ZM44 42H48V50H44V42ZM36 42H40V50H36V42ZM28 42H32V50H28V42ZM20 42H24V50H20V42ZM44 54H48V62H44V54ZM36 54H40V62H36V54ZM28 54H32V62H28V54ZM20 54H24V62H20V54ZM44 66H48V74H44V66ZM36 66H40V74H36V66ZM28 66H32V74H28V66ZM20 66H24V74H20V66ZM44 78H48V88H44V78ZM20 78H24V88H20V78ZM80 36H84V40H80V36ZM72 36H76V40H72V36ZM64 36H68V40H64V36ZM80 44H84V48H80V44ZM72 44H76V48H72V44ZM64 44H68V48H64V44ZM80 52H84V56H80V52ZM72 52H76V56H72V52ZM64 52H68V56H64V52ZM80 60H84V64H80V60ZM72 60H76V64H72V60ZM64 60H68V64H64V60ZM80 68H84V72H80V68ZM72 68H76V72H72V68ZM64 68H68V72H64V68ZM80 76H84V80H80V76ZM72 76H76V80H72V76ZM64 76H68V80H64V76ZM80 84H84V88H80V84ZM72 84H76V88H72V84ZM64 84H68V88H64V84ZM30 78H38V94H30V78Z",
  fill: "black"
});

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.22aa5c7b.svg";
export { ForwardRef as ReactComponent };